import { Base64 } from "js-base64";
import dxButton from "devextreme/ui/button";
import dxLoadPanel from "devextreme/ui/load_panel";
import dxNotify from "devextreme/ui/notify";
import dxPopup from "devextreme/ui/popup";
import dxSelectBox from "devextreme/ui/select_box";
import dxTagBox from "devextreme/ui/tag_box";
import { NodejsAdonis } from "../componentes-padrao/AxiosConfig";
import ControleSessao from "../componentes-padrao/ControleSessao";
import MenuNavegacaoEmbarcadora from "../componentes-padrao/MenuNavegacaoEmbarcadora";
import { analyticsApi } from "../modules/Axios/api";
import {
    getBranchesAllowedForShipper,
    getShippersAllowed,
    setEmbarcadora,
} from "../services/auth/api";
import { setUserTheme } from "../services/user-theme";
import { PopUpAtualizacao } from "../telas/jornada/PopUpAtualizacao";

export class LoginEmbarcadora {
    constructor() {
        // Gera HTML novamente caso tenha sido trocado de empresa
        if ($("#drawer").length == 0) {
            $(".raster-app").append("<div id='drawer' />");
            $(".raster-app").append("<div id='loading' />");
            $(".raster-app").append("<div id='popup' />");

            $("#drawer").append("<div id='tabpanel' />");
            $("#tabpanel").append("<div id='tabpanel-container' />");
        }

        this.renderCampoEmbarcadora = this.campoEmbarcadora();
        this.renderCampoFiliaisEmbarcadora = this.campoFiliaisEmbarcadora();
        this.renderButtonSubmit = this.buttonSubmit();

        this._evtListner = (evt) => this.evtListnerKeypress(evt);

        this.render();
    }

    render() {
        const content = $("#popup");
        this.popupSelecionaEmpresas = new dxPopup(content, {
            dragEnabled: false,
            visible: true,
            title: "Embarcadora/filial",
            fullScreen: false,
            resizeEnabled: false,
            showCloseButton: false,
            deferRendering: false,
            width: () => {
                if (window.innerWidth > 450) {
                    return "450px";
                }
                return `${window.innerWidth - 108}px`;
            },
            height: "auto",
            shadingColor: "rgba(17, 95, 157, 0)",
            position: { my: "center", at: "center", of: window },
            contentTemplate: (conteudo) => {
                $(`<div class="selecionar-empresa-logo"/>`).appendTo(conteudo);

                this.renderCampoEmbarcadora.content.appendTo(
                    $(
                        "<div style='margin-top: 15px;'>Embarcadora:</div>",
                    ).appendTo(conteudo),
                );
                this.renderCampoFiliaisEmbarcadora.content.appendTo(
                    $("<div style='margin-top: 15px;'>Filiais:</div>").appendTo(
                        conteudo,
                    ),
                );
                this.renderButtonSubmit.content.appendTo(
                    $(
                        "<div style='float: right; margin-bottom: 5px; margin-top: 10px; margin-right: 0;' id='avanca-empresa-filial' />",
                    ).appendTo(conteudo),
                );

                document
                    .querySelector("body")
                    .addEventListener("keypress", this._evtListner);
            },
            onShown: () => {
                setTimeout(() => {
                    try {
                        const select_box = this.renderCampoEmbarcadora.instance;

                        if (!select_box.option("disabled")) {
                            select_box.focus();
                        }
                    } catch (err) {
                        console.error("Erro ao focar campo empresa:", err);
                    }
                }, 20);
            },
            onHiding: (e) => (e.cancel = true),
        });
        this.popupSelecionaEmpresas.show();

        const fundoLogin = $(`<div class="bg-imagem"></div>`);
        content.append(fundoLogin);

        return content;
    }

    campoEmbarcadora() {
        const content = $("<div />");

        const instance = new dxSelectBox(content, {
            dataSource: [],
            displayExpr: "reason",
            valueExpr: "id",
            searchEnabled: true,
            disabled: true,
            placeholder: "Carregando... Aguarde.",
            onValueChanged: ({ value, component }) => {
                this.renderCampoFiliaisEmbarcadora.instance.option("value", []); // Limpa selecao de filial ao trocar de embarcadora
                this.renderCampoFiliaisEmbarcadora.instance.option(
                    "placeholder",
                    "Carregando... Aguarde.",
                );
                this.renderCampoFiliaisEmbarcadora.instance.option(
                    "disabled",
                    true,
                );
                component.option("validationStatus", "valid");

                sessionStorage.setItem("REPORT_KEY", Base64.encode(value));

                getBranchesAllowedForShipper(value).then((branches) => {
                    this.renderCampoFiliaisEmbarcadora.instance.option(
                        "dataSource",
                        branches,
                    );
                    this.renderCampoFiliaisEmbarcadora.instance.option(
                        "disabled",
                        false,
                    );
                    this.renderCampoFiliaisEmbarcadora.instance.option(
                        "placeholder",
                        "Selecione as filiais",
                    );
                    // Seleciona todas as filiais por padrao, mantendo a lista fechada
                    this.renderCampoFiliaisEmbarcadora.instance.option(
                        "value",
                        branches.map((branch) => branch.id),
                    );
                });
            },
        });

        getShippersAllowed().then((shippers) => {
            instance.option("dataSource", shippers);
            instance.option("disabled", false);
            instance.option("placeholder", "Selecione uma embarcadora");

            if (shippers.length === 1) {
                instance.option("value", shippers[0].id);
            } else {
                instance.open();
            }
        });

        return {
            content,
            instance,
        };
    }

    campoFiliaisEmbarcadora() {
        const content = $("<div />");

        const instance = new dxTagBox(content, {
            displayExpr: "reason",
            valueExpr: "id",
            showSelectionControls: true,
            multiline: false,
            dataSource: [],
            disabled: true,
            placeholder: "Selecione uma filial",
            onValueChanged: ({ component }) => {
                component.option("validationStatus", "valid");
            },
        });

        return {
            content,
            instance,
        };
    }

    buttonSubmit() {
        const loading = new dxLoadPanel($(".loadpanel"), {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { my: "center", at: "center" },
            visible: false,
            showIndicator: true,
            showPane: true,
            shading: true,
            closeOnOutsideClick: false,
            message: "Carregando, aguarde.",
        });

        const content = $('<div id="login-button" />');
        const instance = new dxButton(content, {
            icon: "chevronright",
            type: "normal",
            text: "Prosseguir",
            stylingMode: "outlined",
            onClick: async () => {
                try {
                    const embarcadoraValue =
                        this.renderCampoEmbarcadora.instance.option("value");
                    const filiaisEmbarcadoraValue =
                        this.renderCampoFiliaisEmbarcadora.instance.option(
                            "value",
                        );

                    if (!embarcadoraValue || !filiaisEmbarcadoraValue.length) {
                        if (!embarcadoraValue)
                            this.renderCampoEmbarcadora.instance.option(
                                "validationStatus",
                                "invalid",
                            );
                        if (!filiaisEmbarcadoraValue.length)
                            this.renderCampoFiliaisEmbarcadora.instance.option(
                                "validationStatus",
                                "invalid",
                            );
                        return;
                    }

                    loading.show();

                    await this.setEmbarcadoraLogada(
                        embarcadoraValue,
                        filiaisEmbarcadoraValue,
                    );

                    const { menuFiliais } = this.getFiliaisSelecionadas(
                        filiaisEmbarcadoraValue,
                    );

                    ControleSessao.setFiliais(
                        menuFiliais.map((filial) => {
                            return {
                                CAB_CODIGO: filial.CAB_CODIGO,
                                CAB_RAZAO: filial.CAB_RAZAO,
                            };
                        }),
                    );

                    loading.hide();

                    this.popupSelecionaEmpresas.dispose();

                    document
                        .querySelector("body")
                        .removeEventListener("keypress", this._evtListner);

                    if ($(".dx-drawer-panel-content").length) {
                        $(".dx-drawer-panel-content").attr("style", "");
                        $(".dx-drawer-panel-content").html("");
                        $("#toolbar").html("");
                    }

                    // Remove elementos DOM relacionados a popup após fecha-lo
                    $("#popup").remove();
                    $(".raster-app").append("<div id='popup' />");

                    let dezSegundos = 10000;
                    analyticsApi
                        .get("/notice", { timeout: dezSegundos })
                        .then((response) => {
                            const resultadoBusca = response.data;
                            if (resultadoBusca) {
                                const linkLabel =
                                    resultadoBusca.link?.label ||
                                    resultadoBusca.link?.url;
                                const popupAtualizacao = new PopUpAtualizacao(
                                    resultadoBusca.title || undefined,
                                    resultadoBusca.description
                                        ? resultadoBusca.description.slice(
                                              0,
                                              2000,
                                          )
                                        : undefined,
                                    resultadoBusca.image_url
                                        ? resultadoBusca.image_url.trim() ||
                                          undefined
                                        : undefined,
                                    resultadoBusca.link?.url
                                        ? resultadoBusca.link.url
                                        : undefined,
                                    linkLabel
                                        ? linkLabel.slice(0, 200)
                                        : undefined,
                                    resultadoBusca.variant || undefined,
                                );

                                popupAtualizacao
                                    .getRender()
                                    .appendTo(document.body);
                                popupAtualizacao.getDxPopUp().show();
                            } else {
                                console.error(
                                    "Nenhum dado recebido de RELEASE API.",
                                );
                            }
                        })
                        .catch((error) => {
                            console.error("Erro ao buscar dados:", error);
                        });

                    await setUserTheme();

                    new MenuNavegacaoEmbarcadora(
                        this.renderCampoEmbarcadora.instance.option("text"),
                        menuFiliais,
                    ).render();
                } catch (error) {
                    console.log(error);
                    dxNotify("Tente novamente.", "error", 2500);
                } finally {
                    loading.dispose();
                }
            },
        });

        return {
            content,
            instance,
        };
    }

    evtListnerKeypress(evt) {
        if (evt.key == "Enter") {
            this.renderButtonSubmit.content.click();
        }
    }

    getFiliaisSelecionadas(filiais) {
        const dataSourceFiliais =
            this.renderCampoFiliaisEmbarcadora.instance.option("dataSource");

        const filialSelecionadas = filiais.map((filialID) => {
            const filial = dataSourceFiliais.find(
                (item) => item.id === filialID,
            );
            return {
                CAB_CODIGO: filial.id,
                CAB_RAZAO: filial.reason,
            };
        });

        const itemMenuFiliais = filialSelecionadas.map((filial) => ({
            ...filial,
            disabled: true,
        }));

        return { menuFiliais: itemMenuFiliais };
    }

    async setEmbarcadoraLogada(embarcadoraID, filialIDs) {
        await setEmbarcadora({
            embarcadoraID: embarcadoraID,
            filialIDs: filialIDs,
        });
    }
    logUserAccess() {
        NodejsAdonis.post("jor/acessos");
    }
}
